/** Máscara para CPF */
const MascaraCPF = [ /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/ ];
/** Máscara para CNPJ */
const MascaraCNPJ = [ /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/ ];

/**
 * Máscaras para cada tipo de documento
 */
const MascaraDocumento = {
    'CPF': MascaraCPF,
    'CNPJ': MascaraCNPJ
};

export { MascaraDocumento, MascaraCPF, MascaraCNPJ };